import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import es_json from './translations/es/global.json'
import en_json from './translations/en/global.json'


i18next.init({
  interpolation: {escapeValue: false},
  lng: 'es',
  supportedLngs: ['en', 'es'],
  resources: {
    es: {
      global: es_json
    },
    en: {
      global: en_json
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
    <App />
    </I18nextProvider>
  </React.StrictMode>
);